import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';

import './styles.css';

const Main: React.FC = ({children}) => {
  return (
    <div className='main-content'>
      <Sidebar />
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <Topbar />
        <Breadcrumb />
        <div className='mh-page-content'>
          {children}
        </div>
        <div className='mh-copyright'>
          <p>Gerenciador de Ambientes by Microhouse Informática</p>
          <p style={{ marginRight: '32px' }}>All Rights Reserved</p>
        </div>
      </div>
    </div>
  );
}

export default Main;